import React, { CSSProperties } from 'react';

import styled from 'styled-components';

import { MediaQuery } from '../../components/Common';

import images from '../../assets';

export const PageTitle = ({ children, style }) => {
  return (
    <>
      <MediaQuery min={500}>
        <div style={{ fontSize: 42, lineHeight: '42px', fontFamily: 'NSCJKrB', color: 'black', ...style }}>
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={499}>
        <div style={{ fontSize: 30, lineHeight: '30px', fontFamily: 'NSCJKrB', color: 'black', ...style }}>
          {children}
        </div>
      </MediaQuery>
    </>
  );
};

const TagpageDescipt = styled.div`
  font-size: 18px;
  font-family: 'NSCJKrR';
  color: '#666666';
  line-height: 18px;
`;

const TagminpageDescipt = styled.div`
  font-size: 16px;
  font-family: 'NSCJKrR';
  color: '#666666';
  line-height: 16px;
`;

export const PageDescipt = ({ children, ...props }) => {
  return (
    <>
      <MediaQuery min={500}>
        <TagpageDescipt {...props}>{children}</TagpageDescipt>
      </MediaQuery>
      <MediaQuery max={499}>
        <TagminpageDescipt {...props}>{children}</TagminpageDescipt>
      </MediaQuery>
    </>
  );
};

export const InputErrMsg = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: red;
  line-height: 24px;
  height: 24px;
`;

export const InputMsg = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: #007bee;
  line-height: 24px;
  height: 24px;
`;

export const InputGroup = styled.div`
  height: 40px;
  border-bottom: 1px solid #999999;
`;

export const InputPad = styled.div`
  display: flex;
  align-items: center;
`;

export const InputPlaceHolder = styled.div`
  position: absolute;
  left: 9px;
  top: 9px;
  height: 36px;
  z-index: -1;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #999999;
  font-family: 'NSCJKrR';
`;

export const inputStyle = {
  fontFamily: 'NSCJKrR',
  fontSize: 16,
  color: 'black',
  width: '100%',
};

export const AuthButton = styled.div`
  font-family: 'NSCJKrB';
  font-size: 18px;
  background-color: #fe8b07;
  color: white;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
`;

export const AuthMiniButton = styled.div`
  font-family: 'NSCJKrB';
  font-size: 18px;
  background-color: #fe8b07;
  color: white;
  width: 186px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 1px;
`;

export const OrSplite = () => {
  return (
    <div style={{ position: 'relative', height: 1, borderBottom: '1px solid #f3f3f3', width: '100%' }}>
      <div
        style={{
          position: 'absolute',
          left: 0,
          bottom: -7,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: 130,
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            textAlign: 'center',
            backgroundColor: 'white',
            lineHeight: '16px',
          }}
        >
          OR
        </div>
      </div>
    </div>
  );
};

export const SNSRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SNSButton = styled.div`
  cursor: pointer;
`;

export const SnSNaver = ({ ...props }) => {
  return (
    <SNSButton SNSButton {...props} id="naver-login">
      <img alt="" src={images.sns_naver} style={{ maxWidth: 61, width: '100%', height: 'auto' }} />
      <div id="naver_id_login" style={{ display: 'none' }}></div>
    </SNSButton>
  );
};

export const SnSKakao = ({ ...props }) => {
  return (
    <SNSButton {...props}>
      <img alt="" src={images.sns_kakao} style={{ maxWidth: 61, width: '100%', height: 'auto' }} />
    </SNSButton>
  );
};

export const SnSFaceBook = ({ ...props }) => {
  return (
    <SNSButton {...props}>
      <img alt="" src={images.sns_facebook} style={{ maxWidth: 61, width: '100%', height: 'auto' }} />
    </SNSButton>
  );
};

export const SnSApple = ({ ...props }) => {
  return (
    <SNSButton {...props}>
      <img alt="" src={images.sns_apple} id="appleid-signin" style={{ maxWidth: 61, width: '100%', height: 'auto' }} />
    </SNSButton>
  );
};
export const SnSGoogle = ({ ...props }) => {
  return (
    <SNSButton {...props} id="google-login">
      <img alt="" src={images.sns_google} style={{ maxWidth: 61, width: '100%', height: 'auto' }} />
    </SNSButton>
  );
};

export const ForgetSign = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
`;

export const SubBtn = styled.div`
  padding: 0 10px;
  cursor: pointer;
`;
export const AutoForm = ({ children, width = 500, height = 760 }) => {
  return (
    <>
      <MediaQuery min={550}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: height }}>
          <div
            style={{
              width: width,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {children}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery max={549}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '30px 0px',
            marginBottom: 20,
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {children}
          </div>
        </div>
      </MediaQuery>
    </>
  );
};

export const CheckMark = ({ checked }) => {
  return (
    <>
      <MediaQuery min={550}>
        <img
          alt=""
          src={checked ? images.icon_checked : images.icon_checknor}
          style={{ height: 18, width: 'auto', marginRight: 10, marginTop: 2 }}
        />
      </MediaQuery>
      <MediaQuery max={549}>
        {/* <img
          alt=""
          src={checked ? images.icon_checked : images.icon_checknor}
          style={{ height: 18, width: 'auto', marginRight: 6, marginTop: 2 }}
        /> */}
        <div style={{display:"flex", alignItems:"center", justifyContent: "center"}}>
          <img
            alt=""
            src={checked ? images.icon_checked : images.icon_checknor}
            style={{ height: 18, marginRight: 8, width: 'auto', }}
          />
        </div>
      </MediaQuery>
    </>
  );
};

export const disabledCheckMark = ({ checked }) => {
  return (
    <>
      <MediaQuery min={550}>
        <img
          alt=""
          src={images.icon_disable_checknor}
          style={{ height: 18, width: 'auto', marginRight: 10, marginTop: 2 }}
        />
      </MediaQuery>
      <MediaQuery max={549}>
       
        <div style={{display:"flex", alignItems:"center", justifyContent: "center"}}>
          <img
            alt=""
            src={images.icon_disable_checknor}
            style={{ height: 18, width: 'auto', }}
          />
        </div>
      </MediaQuery>
    </>
  );
};



export const CheckBox = styled.div`
  display: flex;
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: black;
  align-items: center;
  line-height: 18px;
  cursor: pointer;
`;
